var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 0C0.801 0 0 0.801 0 1.8V5.4C0 6.399 0.801 7.2 1.8 7.2H5.4C6.399 7.2 7.2 6.399 7.2 5.4V1.8C7.2 0.801 6.399 0 5.4 0M5.58 1.35L6.534 2.295L2.943 5.85L0.666 3.555L1.629 2.61L2.952 3.951M1.8 9C0.801 9 0 9.801 0 10.8V14.4C0 15.399 0.801 16.2 1.8 16.2H5.4C6.399 16.2 7.2 15.399 7.2 14.4V10.8C7.2 9.801 6.399 9 5.4 9M1.8 10.8H5.4V14.4H1.8M9 1.8H18V3.6H9M9 14.4V12.6H18V14.4M9 7.2H18V9H9V7.2Z",
    fill: "#5E05C6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderFilledIcon);
export default __webpack_public_path__ + "static/media/orderFilledIcon.5ad9533c7b87caecf9d14b5e0b0ea9c2.svg";
export { ForwardRef as ReactComponent };